import ConfiguratorBonusContent from "../../Interfaces/ConfiguratorBonusContent";
import VideoWithPoster from "../Displays/VideoWithPoster";
import Image from '../Displays/Image';
import parse from 'html-react-parser';
import { getImageSizes, getSrcSet } from "../../Helpers/WindowHelpers";

interface BonusContentInterface {
    title: string,
    content: ConfiguratorBonusContent
}

const BonusContent = ({ title, content }: BonusContentInterface) => {
    return (<div className="d--flex flex-column gap-10">
        <h2 className="h4 title">{title}</h2>
        <div className="d--flex flex-column gap-20">
            {content?.video?.src ?
                <VideoWithPoster
                    video={content.video}
                    image={content.video.poster ? content.video.poster : content.image}
                /> : null}
            {
                !content.video?.src && content.image?.src ? (
                    <div className="round width--100 mx-auto details-modal-image">
                        <Image
                            classes="d--block width--100"
                            image={content.image}
                            srcSet={[400, 600, 800, 1200, 1600]}
                            sizes={getImageSizes('450px', [{ screen: 1664, view: '520px' }])}
                        />
                    </div>
                ) : null
            }
            <div>{parse(content.richText ?? '')}</div>
            {/* TODO: add quick add to cart */}
        </div>
    </div>)
}

export default BonusContent;